// 3rd party angular modules
import uiRouter from 'angular-ui-router';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
require('angular-moment');
require('angular-clipboard');
require('angular-ui-bootstrap');
require('angularjs-slider');
require('angularjs-slider/dist/rzslider.min.css');
require('@cgross/angular-busy/dist/angular-busy.min.css');
require('@cgross/angular-busy/dist/angular-busy.min.js');
require('selectize/dist/css/selectize.default.css');
require('expose-loader?Selectize!selectize');
require('angular-selectize2/dist/angular-selectize.js');
require('ng-fittext/dist/ng-FitText.min.js');
require('expose-loader?tinycolor!tinycolor2');
require('angularjs-color-picker');
require('angularjs-color-picker/dist/angularjs-color-picker.min.css');
require('angularjs-color-picker/dist/themes/angularjs-color-picker-bootstrap.min.css');
import angulartics from 'angulartics';
import angularticsGoogleAnalytics from 'angulartics-google-analytics';
require('angularjs-toaster');
require('angularjs-toaster/toaster.min.css');
require('ng-file-upload');
require('ng-tags-input');
require('ng-tags-input/build/ng-tags-input.min.css');
require('ng-tags-input/build/ng-tags-input.bootstrap.min.css');
require('chart.js');
require('angular-chart.js');
require('angular-leaflet-directive');
require('angular-vs-repeat');
require('blockadblock');

let module = angular.module('app.thirdparty', [
  'angular-clipboard',
  'ngSanitize',
  'angularMoment',
  'angulartics',
  'angulartics.google.analytics',
  'cgBusy', //angular-busy
  'chart.js',
  'color.picker',
  'ngFileUpload',
  'ngFitText',
  'ngTagsInput',
  'ngResource',
  'rzModule', //angularjs-slider
  'selectize',
  'toaster',
  'ui.bootstrap',
  'ui.router',
  'leaflet-directive',
  'vs-repeat',
]);

module.value('fitTextConfig', {
  config: {
    debounce: _.debounce,
    delay: 100,
    loadDelay: 250,
    min: 13,
    max: 30,
  },
});

// Init Google Analytics
(function (i, s, o, g, r, a, m) {
  i['GoogleAnalyticsObject'] = r;
  (i[r] =
    i[r] ||
    function () {
      (i[r].q = i[r].q || []).push(arguments);
    }),
    (i[r].l = 1 * new Date());
  (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
  a.async = 1;
  a.src = g;
  m.parentNode.insertBefore(a, m);
})(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

ga('create', GOOGLE_ANALYTICS_KEY, GOOGLE_ANALYTICS_DOMAIN);
////

// Init Facebook
window.fbAsyncInit = function () {
  FB.init({
    appId: FACEBOOK_APP_ID,
    xfbml: true,
    cookie: true,
    version: FACEBOOK_API_VERSION,
  });
};
(function (d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  js = d.createElement(s);
  js.id = id;
  js.src = '//connect.facebook.net/en_US/sdk.js';
  fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');
////

// Init DataDog logging
if (window.DD_LOGS) {
  DD_LOGS.init({
    clientToken: DATADOG_LOGS_CLIENT_TOKEN,
    forwardErrorsToLogs: false,
    sampleRate: 100,
  });
  window.remoteLogger = DD_LOGS.logger;
  if (window.location.hostname == 'localhost') {
    // Use console logging for local development
    window.remoteLogger.setHandler('console');
  }
} else {
  console.warn(
    'DD_LOGS not available so remote troubleshooting will be limited. Do you have an ad blocker enabled?'
  );
}
////

export default module;



// WEBPACK FOOTER //
// ./app/thirdparty.js